
import Vue from "vue";
import { ISearchHit, ITemplateFilter, ITranslations } from "../store/state";
import Checkbox from "./Checkbox.vue";
interface TemplateFilterProps {}
interface TemplateFiltersComputed {
  templateFilter: ITemplateFilter[];
  buttonText: string;
  translations: ITranslations;
}
interface TemplateFiltersMethods {
  toggleFilters(): void;
}
export default Vue.extend<
  {},
  TemplateFiltersMethods,
  TemplateFiltersComputed,
  TemplateFilterProps
>({
  name: "TemplateFilter",
  data() {
    return {
      filtersOpen: false,
    };
  },
  props: {},
  computed: {
    templateFilter() {
      console.log("filters: ", this.$store.getters.templateFilter);
      return this.$store.getters.templateFilter;
    },
    buttonText() {
      const selectedFilters = this.$store.getters.templateFilter.filter(
        (f: ITemplateFilter) => f.selected
      );
      const length = selectedFilters.length;
      return selectedFilters.length > 0
        ? length > 1
          ? `${length} ${this.translations.pageTypesPicked}`
          : `${length} ${this.translations.pageTypePicked}`
        : this.translations.allTypes;
    },
    translations() {
      return this.$store.getters.translations;
    },
  },
  methods: {
    toggleFilters() {
      this.$data.filtersOpen = !this.$data.filtersOpen;
    },
  },
  mounted() {
    ["click", "focusin"].forEach((eventName) => {
      window.addEventListener(eventName, (e) => {
        const wrapper = this.$refs.filterWrapper as HTMLElement;
        const target = e.target as HTMLElement;

        if (wrapper) {
          if (!wrapper.contains(target) && this.$data.filtersOpen) {
            this.toggleFilters();
          }
        }
      });
    });
  },
  components: {
    Checkbox,
  },
});
